<template>

    <div>
      <StudentsListFilters v-if="!isTrashedTableActive" />
  
      <!-- Table Container Card -->
      <BCard no-body class="mb-0" >
  
        <div class="m-2">
          <BRow>
            <BCol cols="12" md="3"  xxl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
              <label>{{$t('Show')}}</label>
              <vSelect v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>
              <!-- Search -->
            <BCol cols="12"  md="9" xxl="6"   >
              <div class="d-flex align-items-center justify-content-between">
                <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BButton  :variant="isTrashedTableActive ? 'danger' : 'outline-danger'" class="mr-1" @click="changeTable()" v-if="ability.can('delete', 'student')">
                  <FeatherIcon icon="TrashIcon" />
                </BButton>
                <BDropdown  id="dropdown-3" text="Listados" variant="danger" class="mr-1">
                  <BDropdownItem @click="showModalDates(0)">Impagos</BDropdownItem>
                  <BDropdownItem @click="showModalDates(1)" v-if="user.role == 'Superadministrador'">Pagos</BDropdownItem>
                  <BDropdownItem @click="showModalDates(false, 'corrective')" v-if="user.role == 'Superadministrador'">Abonos</BDropdownItem>

                  <BDropdownItem @click="bonusStudentsPDF">Bonos</BDropdownItem>
                </BDropdown>
                <BDropdown  id="dropdown-3" text="Exportar" variant="success" class="mr-1">
                  <BDropdownItem @click="downloadPDF">PDF</BDropdownItem>
                  <BDropdownItem @click="downloadCSV">CSV</BDropdownItem>
                  <BDropdownItem @click="downloadXLS">XLS</BDropdownItem>
                </BDropdown>
                <BButton  variant="primary" :to="{ name: 'students-add' }" v-if="ability.can('create', 'student')">
                  <span class="text-nowrap">{{$t('Add Student')}}</span>
                </BButton>
              </div>
            </BCol>
          </BRow>
  
        </div>
  
        <!--  -->
        <BTable ref="trashedStudentTable" :items="trashedStudents" :fields="trashedStudentsColumns" v-if="isTrashedTableActive" responsive show-empty empty-text="No hay alumnos en la papelera">

          <template #cell(student)="data">
            <span><b>{{ data.item.full_name }}</b></span><br>
            <span class="text-muted"><small>{{ data.item.dni }} | {{ data.item.email }}</small></span>
          </template>

          <!-- Columna: Acciones -->
          <template #cell(actions)="data">
            <BButton variant="primary" class="mr-1" @click="restoreStudentfn(data.item.id)">
              <FeatherIcon icon="RewindIcon" class="mr-1" />
              <span>Restaurar</span>
            </BButton>
            <!-- <BButton variant="danger">
              <FeatherIcon icon="Trash2Icon" class="mr-1" @click="detroyStudent(data.item.id)" />
              <span>Eliminar completamente</span>
            </BButton> -->
          </template>

        </BTable>

        <BTable ref="studentTable" class="position-relative" :items="fetchStudents" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No matching records found" :sort-desc.sync="isSortDirDesc" v-else>
  
          <!-- Column: User -->
          <template #cell(name)="data">
            <BMedia vertical-align="center">
              <template #aside>
                <BAvatar size="40" :src="data.item.avatar" :text="avatarText(data.item.full_name)" :to="{ name: 'students-view', params: { id: data.item.id } }" />
              </template>
              <BLink :to="{ name: 'students-view', params: { id: data.item.id } }" class="font-weight-bold d-block text-nowrap" > {{ data.item.full_name }} </BLink>
              <small class="text-muted">{{ data.item.dni }}</small>
            </BMedia>
          </template>

          <template #cell(contact_data)="data">
            <BMedia vertical-align="center">
              <p class="text-nowrap m-0 p-0"> {{ data.item.email}} </p>
              <small class="text-muted">{{ data.item.phone }}</small>
            </BMedia>
          </template>
  
          <!-- Column: Group -->
          <template #cell(groups)="data">
              <span v-for="group in data.item.groups" :key="group.id">
                <BBadge variant="light-info" :to="{ name: 'groups-view', params: { id: group.id } }" class="mr-1" v-if="ability.can('read', 'group')"> {{ group.name }} </BBadge>
                <BBadge variant="light-info" class="mr-1" v-else> {{ group.name }} </BBadge>
              </span>
          </template>
  
          <!-- Column: Status -->
          <template #cell(status)="data">
            <BBadge pill :variant="`light-${resolveStudentStatusVariant(data.item.status)}`" class="text-capitalize" v-if="data.item.status == 1"> {{ $t('Active') }} </BBadge>
            <BBadge pill :variant="`light-${resolveStudentStatusVariant(data.item.status)}`" class="text-capitalize" v-if="data.item.status == 0"> {{ $t('Inactive') }} </BBadge>
            <BBadge pill :variant="`light-${resolveStudentStatusVariant(data.item.status)}`" class="text-capitalize" v-if="data.item.status == -1"> {{ $t('Pending') }} </BBadge>
          </template>
  
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL" >
  
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <BDropdownItem :to="{ name: 'students-view', params: { id: data.item.id } }" v-if="ability.can('read', 'student')">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{ $t('Details') }}</span>
              </BDropdownItem>
  
              <BDropdownItem :to="{ name: 'students-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'student')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t('Edit') }}</span>
              </BDropdownItem>

              <BDropdownItem @click="regeneratePassword(data.item.id)" v-if="ability.can('write', 'student')">
                <feather-icon icon="RefreshCwIcon" />
                <span class="align-middle ml-50">Enlace regeneración contraseña</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopup(data.item.id, 'students/deleteStudent', '', data.item.dni)" v-if="ability.can('delete', 'student')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </BDropdownItem>
            </BDropdown>
          </template>
  
        </BTable>

        <!-- Paginación -->
        <div class="mx-2 mb-2" v-if="!isTrashedTableActive">
          <BRow>
  
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
              <span class="text-muted">{{$t('Showing')}} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{$t('of')}} {{ dataMeta.of }} {{$t('entries')}}</span>
            </BCol>

            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end" >
              <BPagination v-model="currentPage" :total-rows="totalStudents" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </BPagination>
            </BCol>
  
          </BRow>
        </div>
      </BCard>

      <BModal ref="datesModal" centered hide-footer no-close-on-backdrop >
            <BRow>
              <BCol class="mt-1" cols="12">
                <label>{{ $t('Group') }}</label>
                <vSelect v-model="selectedGroup" :options="groupOptions" label="name" class="w-100" :reduce="val => val.id" />
              </BCol>
              <BCol class="mt-1" cols="12" v-if="!selectedAllCourses && !downloadCorrective">
                <label>Curso [*Selecciona una sucursal primero]</label>
                <vSelect v-model="selectedCourse" @search="fetchCourses" :options="courseOptions" label="search_name" class="w-100" :reduce="val => val.id" />
              </BCol>
              <BCol class="mt-1" cols="12" v-if="!downloadCorrective">
                <CheckboxValidated vsName="all_courses" :vsModel.sync="selectedAllCourses" vsLabel="Todos los cursos" class="p-0" />
                <CheckboxValidated v-if="selectedAllCourses" vsName="active_courses" :vsModel.sync="selectedActiveCourses" vsLabel="Cursos activos e inactivos" class="p-0" />
              </BCol>

              <BCol class="mt-1" cols="12">
                <!-- <DatepickerValidated vsName="Start date" :vsModel.sync="startDateModal" vsRequired vsRules="required" class="p-0"/> -->
                <MonthpickerValidated vsName="Mes" vsRequired vsRules="required" :vsModel.sync="startDateModal"></MonthpickerValidated>
              </BCol>
              <BCol class="mt-1" cols="12">
                <!-- <MonthpickerValidated vsName="Month picker" :vsModel.sync="endDateModal"></MonthpickerValidated> -->

                <!-- <DatepickerValidated vsName="End date" :vsModel.sync="endDateModal" vsRequired vsRules="required" class="p-0" :vsMin="startDateModal"/> -->
              </BCol>
              <BCol class="mt-3" cols="12">
                <BButton @click="downloadNonPayments()" variant="primary">Exportar</BButton>
              </BCol>
            </BRow>
    </BModal>
    </div>
  
  </template>
  
<script>
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination } from 'bootstrap-vue'
import { ref, onUnmounted, provide, watch } from '@vue/composition-api'
import { exportStudents, getTrashedStudents, restoreStudent } from '@/composables/studentService'
import { getCourses } from '@/composables/courseService'
import { avatarText } from '@core/utils/filter'
import StudentsListFilters from './StudentsListFilters.vue'
import studentListQuery from './studentListQuery'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import store from '@/store'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import MonthpickerValidated from '@/components/forms/MonthpickerValidated.vue'
import axios from '@axios'

import exportUtils from '@/hooks/exportUtils'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import studentModule from '../studentModule'

export default {
    components: { StudentsListFilters, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, DatepickerValidated, CheckboxValidated, TextInputValidated, MonthpickerValidated },
    setup() {
        const { fetchStudents, tableColumns, perPage, currentPage, totalStudents, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, studentTable, refetchData, resolveStudentStatusVariant, groupFilter, statusFilter, groupOptions } = studentListQuery()
        const { deletePopup, errorToast, successToast } = popups()
        const { exportData } = exportUtils()
        const user = JSON.parse(localStorage.getItem('userData'));
        const isAddNewStudentSidebarActive = ref(false)
        const STUDENTS_MODULE = 'students'
        const courseOptions = ref([])
        const trashedStudents = ref([])
        const trashedStudentTable = ref(null)
        const isTrashedTableActive = ref(false)
        const statusOptions = [
            { label: i18n.t('Active'), value: 1 },
            { label: i18n.t('Inactive'), value: 0 },
        ]
        const trashedStudentsColumns = [
          { key: 'student', label: 'Alumno' },
          { key: 'actions', label: 'Acciones' }
        ]

        // Modal para descargar facturas
        const datesModal = ref('')
        const startDateModal = ref(null)
        const endDateModal = ref(null)
        const paidStatus = ref(null)
        const selectedGroup = ref(null)
        const selectedCourse = ref(null)
        const selectedAllCourses = ref(false)
        const selectedActiveCourses = ref(false)
        const downloadCorrective = ref(null)

        provide('groups', groupOptions)
        provide('status', statusOptions)
        provide('groupFilter', groupFilter)
        provide('statusFilter', statusFilter)

        /**
         * Obtener cursos
         * @param {*} val filtros
         */
        const fetchCourses = async function (val) {
            let data = { q: val, group: selectedGroup.value }
            courseOptions.value = await getCourses(data)
        }        

        /**
         * Obtener alumnos eliminados
         */
        const fetchTrashedStudents = async function() {
            trashedStudents.value = await getTrashedStudents()
        }

        /**
         * Restaurar alumno de la papelera
         * @param {integer} student_id id de alumno
         */
        const restoreStudentfn = async function(student_id) {
            let res = await restoreStudent(student_id)
            if (res.success) {
              successToast('Alumno restaurado desde la papelera', 'Restaurado')
            } else {
              errorToast('No se ha podido restaurar el alumno de la papelera', 'Error al restaurar')
            }
            fetchTrashedStudents()
            trashedStudentTable.value.refresh()
        }

        /**
         * Mostrar modal de selección de fechas
         * @param {*} paid 
         */
        const showModalDates = (paid, type=null) => {
            paidStatus.value=paid
            startDateModal.value=null
            endDateModal.value=null
            selectedGroup.value=null
            downloadCorrective.value=type

            datesModal.value.show()
        }

        /**
         * Descargar listado de pagos/impagos
         */
        const downloadNonPayments = () => {

            if (!selectedGroup.value) {
                errorToast('Introduce una sucursal.')
                return
            }

            if (!startDateModal.value) {
                errorToast('Introduce el mes.')
                return
            }

            if (!downloadCorrective.value && (selectedAllCourses.value==false && selectedActiveCourses.value==false && !selectedCourse.value)) {
                errorToast('Selecciona un curso/s.')
                return
            }

            let dataExport = {
                startDate: startDateModal.value,
                endDate: endDateModal.value,
                course: selectedAllCourses.value ? 'all' : selectedCourse.value,
                active: selectedActiveCourses.value,
                group: selectedGroup.value,
                paid: paidStatus.value
            }

            if  (downloadCorrective.value=="corrective") {
                const resp = exportData('download-corrective-non-payments', dataExport, 'listadoAbonos', 'PDF')
            } else if (paidStatus.value == true){
                exportData('download-non-payments', dataExport, 'listado_pagos_'+startDateModal.value, 'PDF')
            } else {
                exportData('download-non-payments', dataExport, 'listado_impagos_'+startDateModal.value, 'PDF')
            }

            datesModal.value.hide()
        }

        /**
         * Exportar alumnos en PDF
         */
        const downloadPDF = () => {
            let data = { type: "PDF",  q: searchQuery.value,  group: groupFilter.value,  status: statusFilter.value }
            exportStudents(data, 'PDF')
        }

        /**
         * Exportar alumnos en CSV
         */
        const downloadCSV = function(){
            let data = { type: "CSV",  q: searchQuery.value,  group: groupFilter.value,  status: statusFilter.value }
            exportStudents(data, 'CSV')
        }

        /**
         * Exportar alumnos en XLS
         */
        const downloadXLS = function(){
            let data = { type: "XLS",  q: searchQuery.value,  group: groupFilter.value,  status: statusFilter.value }
            exportStudents(data, 'XLS')
        }

        /**
         * Descargar listado de bonos de alumnos
         */
        const bonusStudentsPDF = function() {
            const resp = exportData('download-bonus-students', null, 'bonosAlumnos', 'PDF')
            if (resp) {
                successToast('PDF descargado')
            } else {
                errorToast('No se ha podido descargar el PDF')
            }
        }

        /**
         * Alternar entre tabla de borrados y tabla de activos
         */
        const changeTable = async function() {
          isTrashedTableActive.value = !isTrashedTableActive.value
          if(isTrashedTableActive.value) {
            await fetchTrashedStudents()
          }
        }

        const regeneratePassword = (st_id) => {
          axios.post('students/resend-password-link', { id: st_id }).then((response) => {
            if (response.data.success) {
              successToast('Contraseña regenerada correctamente')
            }
          }).catch((error) => {
            errorToast(error)
          })
        }

        watch(selectedGroup, () => {
            if (selectedGroup.value == null) {
                selectedCourse.value = null
                courseOptions.value = []
            } else {  
                fetchCourses()
            }
        });

      if (!store.hasModule(STUDENTS_MODULE)) store.registerModule(STUDENTS_MODULE, studentModule)

      onUnmounted(() => {
         if (store.hasModule(STUDENTS_MODULE)) store.unregisterModule(STUDENTS_MODULE) 
      })
  
        return {
            isAddNewStudentSidebarActive,
            fetchStudents,
            tableColumns,
            perPage,
            currentPage,
            totalStudents,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            studentTable,
            refetchData,
            avatarText,
            resolveStudentStatusVariant,
            deletePopup,
            ability,
            showModalDates,
            datesModal, 
            downloadNonPayments,
            downloadPDF,
            downloadCSV,
            downloadXLS, 
            startDateModal, 
            endDateModal,
            bonusStudentsPDF,
            selectedGroup,
            selectedCourse,
            selectedAllCourses,
            selectedActiveCourses,
            groupOptions,
            courseOptions,
            fetchCourses,
            user,
            downloadCorrective,
            isTrashedTableActive,
            changeTable,
            trashedStudents,
            trashedStudentsColumns,
            restoreStudentfn,
            trashedStudentTable,
            regeneratePassword
        }
    },
  }
</script>
  
<style lang="scss" scoped>
  .per-page-selector {
    width: 5.625rem;
  }
</style>
  
<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>
  